import React from "react";
import Alert, { AlertProps } from "antd/lib/alert";
import "./index.less";
import ZIcon, { Icons } from "../ZIcon";

const ZAlert: React.FC<AlertProps> = ({
	className = "",
	closable = false,
	closeText = (
		<ZIcon name={Icons.CLOSE} size="sm" colorVariant={8} fill={true} />
	),
	...rest
}) => (
	<Alert
		{...rest}
		className={`z-alert ${className}`}
		closeText={closable ? closeText : null}
	/>
);

export default ZAlert;
